import * as React from 'react'

interface MicrosoftSigninButtonProps {
	microsoftLogin: () => void
	text: string
	width?: string
}

const MicrosoftSigninButton: React.SFC<MicrosoftSigninButtonProps> = (props) => {
	const [hover, setHover] = React.useState(false)

	const btnStyle = {
		backgroundColor: hover ? '#000000ab' : 'black',
		color: 'white',
		border: '1px solid #000',
		height: '2.4em',
		textSizeAdjust: '80%',
		borderRadius: '5px',
		display: 'inline-block',
		width: props.width ? props.width : '100%',
		fontSize: '14px'
	} as React.CSSProperties

	return (
		<button
			className="bsk-btn bsk-btn-default"
			style={btnStyle}
			onClick={props.microsoftLogin}
			onMouseEnter={() => setHover(true)}
			onMouseLeave={() => setHover(false)}
		>
			<span style={{ display: 'flex', alignItems: 'center' }}>
				<object
					type="image/svg+xml"
					data="/images/ms-pictogram.svg"
					style={{ height: '25px', marginRight: '5px' }}
				></object>
				<span style={{ flex: 1, textAlign: 'center' }}>{props.text}</span>
			</span>
		</button>
	)
}

export default MicrosoftSigninButton
